module.exports = __webpack_public_path__ + "09_face.f62e5529.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/09_face.png
// module id = wOSZ
// module chunks = 0